import moment from 'moment';
import { getLocale } from '../misc';

export const FILTER_BY_WEBFORM_OPTIONS = [
  'Business Connect',
  'Wireline/Security',
  'Wireless',
  'MyOD (order tracking tool)',
  'Phone Number Check',
  'Business Connect Contact Centre',
  'Referral Tool',
  'Internet of Things',
  'Business Apps',
  "Fully Managed",
  "PureFibre East"
];

export const FILTER_BY_DEFECT_CATEGORY_OPTIONS = [
  'User Info',
  'Offers & Pricing',
  'Behavioural issue'
];
export const FILTERS_INIT_STATE = {
  defectWebform: '',
  defectCategory: '',
  status: '',
  assignee: '',
  startDate: null,
  endDate: null
};

export const DEFECTS_PER_PAGE = 50;

export const CALCULATE_WORKING_DAYS = (dateStart, dateEnd, includedDays) => {
  let count = 0;
  for (
    let m = moment(dateStart);
    m.diff(dateEnd, 'days') <= 0;
    m.add(1, 'days')
  ) {
    if (includedDays[m.weekday()]) {
      count++;
    }
  }
  return count - 1;
};

export const GET_WORKING_DAYS = moved_to_in_progress_at => {
  return CALCULATE_WORKING_DAYS(
    moment({
      year: new Date(moved_to_in_progress_at).getFullYear(),
      month: new Date(moved_to_in_progress_at).getMonth(),
      day: new Date(moved_to_in_progress_at).getDate()
    }),
    moment({
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      day: new Date().getDate()
    }),
    [false, true, true, true, true, true, false]
  );
};

export const GET_RESOLVED_DAYS = (moved_to_in_progress_at, resolved_at) => {
  return CALCULATE_WORKING_DAYS(
    moment({
      year: new Date(moved_to_in_progress_at).getFullYear(),
      month: new Date(moved_to_in_progress_at).getMonth(),
      day: new Date(moved_to_in_progress_at).getDate()
    }),
    moment({
      year: new Date(resolved_at).getFullYear(),
      month: new Date(resolved_at).getMonth(),
      day: new Date(resolved_at).getDate()
    }),
    [false, true, true, true, true, true, false]
  );
};

export const GET_DEFECT_LOCALE = value => {
  const toEn = {
    //Webform
    'Connexion Affaires': ['Business Connect'],
    'Services filaires/Sécurité': ['Wireline/Security'],
    'Services mobiles': ['Wireless'],
    'Tableau de bord Ma commande (outil de suivi des commandes)': [
      'MyOD (order tracking tool)'
    ],
    'Vérification de numéro de téléphone': ['Phone Number Check'],
    'Centre de contact Connexion Affaires': ['Business Connect Contact Centre'],
    'Outil de recommandation': ['Referral Tool'],
    "Bon de commande de solutions d'IdO de TELUS": ['Internet of Things'],
    "Applications d'affaires TELUS": ['Business Apps'],
    //Category
    'Accès utilisateur/Mises à jour': ['User Access/Updates'],
    'Offres & Tarifs': ['Offers & Pricing'],
    'Problème de comportement': ['Behavioural issue'],
    //Status
    Nouveau: ['New'],
    'En cours': ['In Progress'],
    Résolu: ['Resolved'],
    'Fermé - aucune réponse reçue': ['Closed - No response received'],
    //Priority
    Bas: ['Low'],
    Moyen: ['Medium'],
    Haute: ['High']
  };
  const toFr = {
    //Webform
    'Business Connect': ['Connexion Affaires'],
    'Wireline/Security': ['Services filaires/Sécurité'],
    Wireless: ['Services mobiles'],
    'MyOD (order tracking tool)': [
      'Tableau de bord Ma commande (outil de suivi des commandes)'
    ],
    'Phone Number Check': ['Vérification de numéro de téléphone'],
    'Business Connect Contact Centre': ['Centre de contact Connexion Affaires'],
    'Referral Tool': ['Outil de recommandation'],
    'Internet of Things': ["Bon de commande de solutions d'IdO de TELUS"],
    'Business Apps': ["Applications d'affaires TELUS"],
    //Category
    'User Access/Updates': ['Accès utilisateur/Mises à jour'],
    'Offers & Pricing': ['Offres & Tarifs'],
    'Behavioural issue': ['Problème de comportement'],
    //Status
    New: ['Nouveau'],
    'In Progress': ['En cours'],
    Resolved: ['Résolu'],
    'Closed - No response received': ['Fermé - aucune réponse reçue'],
    //Priority
    Low: ['Bas'],
    Medium: ['Moyen'],
    High: ['Haute']
  };
  const locale = getLocale();
  const listToCheck = locale === 'fr-CA' ? toFr : toEn;
  return listToCheck[value] || value;
};
